/* eslint-disable react/react-in-jsx-scope */
import { FiMoreVertical } from "react-icons/fi";
import FilledButton from "../reusables/Buttons/FilledButton";
import BigNumber from "bignumber.js";
import { getAccountInfo } from "../../methods/contracts/getBalance";
import {
  copyToClipboard,
  formatTransactionHash,
  hasTimeStarted,
} from "../../methods/helper";
import { FiCopy } from "react-icons/fi";

export const myPoolsCols = [
  { label: "Pool Name", field: "pool_name", sort: "asc" },
  { label: "Pool Type", field: "pool_type", sort: "asc" },
  { label: "Unique Identifier", field: "unique_identifier", sort: "asc" },
  { label: "Token To Share", field: "token_share", sort: "asc" },
  { label: "Total Addresses", field: "total_addresses", sort: "asc" },
  { label: "End Date", field: "end_date", sort: "asc" },
  // { label: "", field: "more_vert", sort: "asc" },
];

export const myRewardsCols = [
  { label: "Pool Name", field: "pool_name", sort: "asc" },
  { label: "Pool Type", field: "pool_type", sort: "asc" },
  { label: "Unique Identifier", field: "unique_identifier", sort: "asc" },
  { label: "Token share", field: "token_share", sort: "asc" },
  // { label: "Total Addresses", field: "total_addresses", sort: "asc" },
  { label: "End Date", field: "end_date", sort: "asc" },
  { label: "", field: "claim_button", sort: "asc" },
];

export const myEndedRewardsCols = [
  { label: "Pool Name", field: "pool_name", sort: "asc" },
  { label: "Pool Type", field: "pool_type", sort: "asc" },
  { label: "Unique Identifier", field: "unique_identifier", sort: "asc" },
  { label: "Token share", field: "token_share", sort: "asc" },
  // { label: "Total Addresses", field: "total_addresses", sort: "asc" },
  { label: "End Date", field: "end_date", sort: "asc" },
];

export const myClaimedRewardsCols = [
  { label: "Pool Name", field: "pool_name", sort: "asc" },
  { label: "Pool Type", field: "pool_type", sort: "asc" },
  { label: "Unique Identifier", field: "unique_identifier", sort: "asc" },
  { label: "Token share", field: "token_share", sort: "asc" },
  // { label: "Total Addresses", field: "total_addresses", sort: "asc" },
  { label: "End Date", field: "end_date", sort: "asc" },
  { label: "Transaction Hash", field: "tx_hash", sort: "asc" },
];

export const myPoolsTableRows = async (pools, network) => {
  if (!pools || pools.length === 0) return [];

  const rows = await Promise.all(
    pools.map(async (pool) => {
      // Calculate totalRewardAmount
      const totalRewardAmount = pool.eligibleAddresses.reduce(
        (acc, addr) => acc.plus(new BigNumber(addr.rewardAmount)),
        new BigNumber(0)
      );

      // Handle expiration timestamp
      const adjustedExpirationTime =
        pool.expirationTime > 1e12
          ? pool.expirationTime / 1000
          : pool.expirationTime;
      const expirationDate = new Date(
        adjustedExpirationTime * 1000
      ).toLocaleDateString();

      let tokenSymbol = network?.nativeCurrency?.symbol;

      // If tokenContract is present, fetch token info
      if (pool.tokenContract) {
        try {
          const { symbol } = await getAccountInfo(
            pool.tokenContract,
            pool.eligibleAddresses[0].address
          );
          tokenSymbol = symbol;
        } catch (error) {
          console.error("Error fetching token info:", error);
        }
      }

      return {
        pool_name: <span>{pool.poolName}</span>,
        pool_type: <span>{pool.poolType}</span>,
        unique_identifier: <span>{pool.salt}</span>,
        token_share: (
          <span>
            {totalRewardAmount.toString()} {tokenSymbol}
          </span>
        ),
        total_addresses: <span>{pool.eligibleAddresses.length}</span>,
        end_date: <span>{expirationDate}</span>,
        more_vert: <FiMoreVertical />,
      };
    })
  );

  return rows;
};

export const myRewardsRows = async (pools, claimReward, network) => {
  if (pools && pools.length > 0) {
    const rows = [];

    for (const pool of pools) {
      // Adjust timestamp if too large
      const expirationTime = pool.pool.expirationTime;
      const adjustedExpirationTime =
        expirationTime > 1e12 ? expirationTime / 1000 : expirationTime;

      // Convert to a human-readable date
      const expirationDate = new Date(
        adjustedExpirationTime * 1000
      ).toLocaleDateString();

      if (pool.pool.tokenContract) {
        const { symbol } = await getAccountInfo(
          pool.pool.tokenContract,
          pool.address
        );
        rows.push({
          pool_name: <span>{pool.pool.poolName}</span>,
          pool_type: <span>{pool.pool.poolType}</span>,
          unique_identifier: <span>{pool.pool.salt}</span>,
          token_share: (
            <span>
              {pool.rewardAmount
                ? Number(pool.rewardAmount).toFixed(5)
                : "0.00000"}{" "}
              {symbol}
            </span>
          ),
          end_date: <span>{expirationDate}</span>,
          claim_button: (
            <FilledButton
              btnText={"Claim Reward"}
              handleClick={() => claimReward(pool)}
            />
          ),
        });
      } else {
        rows.push({
          pool_name: <span>{pool.pool.poolName}</span>,
          pool_type: <span>{pool.pool.poolType}</span>,
          unique_identifier: <span>{pool.pool.salt}</span>,
          token_share: (
            <span>
              {pool.rewardAmount
                ? Number(pool.rewardAmount).toFixed(5)
                : "0.00000"}{" "}
              {network?.nativeCurrency?.symbol}
            </span>
          ),
          end_date: <span>{expirationDate}</span>,
          claim_button: (
            <FilledButton
              btnText={"Claim Reward"}
              handleClick={() => claimReward(pool)}
            />
          ),
        });
      }
    }
    return rows;
  }
};

export const myEndedRewardsRows = async (pools, claimReward, network) => {
  if (pools && pools.length > 0) {
    const rows = [];

    for (const pool of pools) {
      // Adjust timestamp if too large
      const expirationTime = pool.pool.expirationTime;
      const adjustedExpirationTime =
        expirationTime > 1e12 ? expirationTime / 1000 : expirationTime;

      // Convert to a human-readable date
      const expirationDate = new Date(
        adjustedExpirationTime * 1000
      ).toLocaleDateString();

      if (pool.pool.tokenContract) {
        const { symbol } = await getAccountInfo(
          pool.pool.tokenContract,
          pool.address
        );
        rows.push({
          pool_name: <span>{pool.pool.poolName}</span>,
          pool_type: <span>{pool.pool.poolType}</span>,
          unique_identifier: <span>{pool.pool.salt}</span>,
          token_share: (
            <span>
              {pool.rewardAmount
                ? Number(pool.rewardAmount).toFixed(5)
                : "0.00000"}{" "}
              {symbol}
            </span>
          ),
          end_date: <span>{expirationDate}</span>,
        });
      } else {
        rows.push({
          pool_name: <span>{pool.pool.poolName}</span>,
          pool_type: <span>{pool.pool.poolType}</span>,
          unique_identifier: <span>{pool.pool.salt}</span>,
          token_share: (
            <span>
              {pool.rewardAmount
                ? Number(pool.rewardAmount).toFixed(5)
                : "0.00000"}{" "}
              {network?.nativeCurrency?.symbol}
            </span>
          ),
          end_date: <span>{expirationDate}</span>,
        });
      }
    }
    return rows;
  }
};
export const myClaimedRewardsRows = async (pools, claimReward, network) => {
  if (pools && pools.length > 0) {
    const rows = [];

    for (const pool of pools) {
      // Adjust timestamp if too large
      const expirationTime = pool.pool.expirationTime;
      const adjustedExpirationTime =
        expirationTime > 1e12 ? expirationTime / 1000 : expirationTime;

      // Convert to a human-readable date
      const expirationDate = new Date(
        adjustedExpirationTime * 1000
      ).toLocaleDateString();

      if (pool.pool.tokenContract) {
        const { symbol } = await getAccountInfo(
          pool.pool.tokenContract,
          pool.address
        );
        rows.push({
          pool_name: <span>{pool.pool.poolName}</span>,
          pool_type: <span>{pool.pool.poolType}</span>,
          unique_identifier: <span>{pool.pool.salt}</span>,
          token_share: (
            <span>
              {pool.rewardAmount
                ? Number(pool.rewardAmount).toFixed(5)
                : "0.00000"}{" "}
              {symbol}
            </span>
          ),
          end_date: <span>{expirationDate}</span>,
          tx_hash: (
            <>
              <span>{formatTransactionHash(pool?.txhash)}</span>
              <FiCopy
                cursor={"pointer"}
                onClick={() => {
                  copyToClipboard(pool?.txhash);
                }}
              />
            </>
          ),
        });
      } else {
        rows.push({
          pool_name: <span>{pool.pool.poolName}</span>,
          pool_type: <span>{pool.pool.poolType}</span>,
          unique_identifier: <span>{pool.pool.salt}</span>,
          token_share: (
            <span>
              {pool.rewardAmount
                ? Number(pool.rewardAmount).toFixed(5)
                : "0.00000"}{" "}
              {network?.nativeCurrency?.symbol}
            </span>
          ),
          end_date: <span>{expirationDate}</span>,
          tx_hash: (
            <>
              <span>{formatTransactionHash(pool?.txhash)}</span>
              <FiCopy
                cursor={"pointer"}
                onClick={() => {
                  copyToClipboard(pool?.txhash);
                }}
              />
            </>
          ),
        });
      }
    }
    return rows;
  }
};
